/**
 * Created by staffanrantzow on 27/09/16.
 */

import axios from 'axios';

class EmploymentCertificateService {

  createFromInvoices (invoiceIds, orderType) {
    return axios.post('backend://employment-certificate', {
      data: {
        attributes: {
          invoice_ids: invoiceIds,
          order_type: orderType
        }
      }
    });
  }

  createFromWorkPeriod (startDate, endDate, orderType) {
    return axios.post('backend://employment-certificate', {
      data: {
        attributes: {
          workdate_start: startDate,
          workdate_end: endDate,
          order_type: orderType
        }
      }
    });
  }

}

export default new EmploymentCertificateService();



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/employment-certificates/employment-certificate-service.js
 **/